<template>
  <v-sheet
    class="w-100 pa-4 my-4"
    border
    rounded
    elevation="1"
    color="background"
  >
    <div
      class="d-flex flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row"
    >
      <!-- Content div -->
      <div class="flex-grow-1">
        <!-- Icono y título de estatus -->
        <div class="d-flex align-center">
          <v-icon
            :color="color"
            :icon="icono"
            size="small"
            class="me-2"
          ></v-icon>
          <p
            class="text-body-1 font-weight-bold text-uppercase"
            :class="texto_color"
          >
            {{ t("estatus-maniobra.etiqueta") }}:
            {{ t("estatus-maniobra." + estatus + ".titulo") }}
          </p>
        </div>
        <!-- Comentarios de revisión de operaciones -->
        <div
          class="text-body-1 text-textDark text-justify mt-2 pl-6"
          v-if="estatus == 4 && comentarios_revision != null"
        >
          {{ comentarios_revision }}
        </div>
        <!-- Texto fijo de estatus -->
        <div class="text-body-1 text-justify mt-2 pl-6" v-else>
          <p class="text-textDark">
            {{ t("estatus-maniobra." + estatus + ".texto") }}
          </p>
          <!--<p class="text-textLight text-body-2" v-if="editable">
                        {{ t("estatus-maniobra." + estatus + ".nota") }}
                    </p>-->
        </div>
      </div>
      <!-- botón para regresar a modo de edición -->
      <!--<div
                v-if="editable"
                class="d-flex align-center justify-center flex-shrink-0"
                :class="{
                    'mt-4': true,
                    'mt-sm-0': true,
                    'ms-sm-4': true,
                }"
            >
                <v-btn :color="color" variant="outlined" @click="editar">
                    {{ t("boton-editar") }}
                </v-btn>
            </div>-->
      <!-- botón para descargar orden de servicio maniobras-->
      <div
        v-if="estatus == 3 || estatus == 4"
        class="d-flex align-center justify-center flex-shrink-0"
        :class="{
          'mt-4': true,
          'mt-sm-0': true,
          'ms-sm-4': true,
        }"
      >
        <v-btn
          :color="color"
          variant="outlined"
          class="text-uppercase"
          append-icon="mdi-file-download-outline"
          @click="descargarOrdenServicio"
          v-if="estatus == 3"
        >
          {{ t("orden-servicio") }}
        </v-btn>
        <!-- botón para ver adicionales -->
        <v-btn
          :color="color"
          variant="outlined"
          class="text-uppercase"
          :href="
            route('forma-dinamica-a.carrito', {
              stand: standId,
              forma: 'adicionales',
            })
          "
          v-else
        >
          {{ t("ver-adicionales") }}
        </v-btn>
      </div>
    </div>
  </v-sheet>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import { computed } from "vue";

const { t } = useI18n();

const props = defineProps({
  item: Object,
  stand: Number,
});

const maniobraId = computed(() => {
  return props.item.id;
});

const estatus = computed(() => {
  if (props.item && props.item.estatus) {
    console.log(props.item.estatus);
    return props.item.estatus;
  }
  return props.estatus;
});

const color = computed(() => {
  if (props.item && props.item.estatus_elementos[0].color) {
    return props.item.estatus_elementos[0].color;
  }
  return "primary";
});

const icono = computed(() => {
  if (props.item && props.item.estatus_elementos[0].icono) {
    return props.item.estatus_elementos[0].icono;
  }
  return "mdi-information";
});

const texto_color = computed(() => {
  if (props.item && props.item.estatus_elementos[0].texto_color) {
    return props.item.estatus_elementos[0].texto_color;
  }
  return "text-primary";
});

const editable = computed(() => {
  if (props.item && props.item.editable) {
    return props.item.editable;
  }
  return 0;
});

const comentarios_revision = computed(() => {
  if (props.item.estatus == 4 || props.item.estatus == 6) {
    return props.item.comentarios_revision;
  }
  return null;
});

const standId = computed(() => {
  return props.stand;
});

const editar = () => {
  let routeName = "";
  let routeParams = { stand: standId.value };

  routeName = "reglas.maniobras.estatus";
  routeParams.maniobra = maniobraId.value;

  if (routeName) {
    router.post(route(routeName, routeParams));
  }
};

const descargarOrdenServicio = () => {
  const url = route("maniobras.pdf", { maniobra: maniobraId.value });
  window.open(url, "_blank");
};
</script>
